import { combineReducers } from 'redux';
import { workspace } from './workspace';
import { data } from './data';

export default combineReducers( {
	data,
	workspace,
} );
